// extracted by mini-css-extract-plugin
export default {"removeHandlers":"InputPhone_removeHandlers__sBOUZ"};